import { render, staticRenderFns } from "./FaultUpdateOrderProcessSwitches.vue?vue&type=template&id=2c7b9036&scoped=true"
import script from "./FaultUpdateOrderProcessSwitches.vue?vue&type=script&lang=js"
export * from "./FaultUpdateOrderProcessSwitches.vue?vue&type=script&lang=js"
import style0 from "./FaultUpdateOrderProcessSwitches.vue?vue&type=style&index=0&id=2c7b9036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7b9036",
  null
  
)

export default component.exports